import { render, staticRenderFns } from "./AndroidMoreEntrance.vue?vue&type=template&id=9ae965e8&scoped=true&"
import script from "./AndroidMoreEntrance.vue?vue&type=script&lang=ts&"
export * from "./AndroidMoreEntrance.vue?vue&type=script&lang=ts&"
import style0 from "./AndroidMoreEntrance.vue?vue&type=style&index=0&id=9ae965e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae965e8",
  null
  
)

export default component.exports